Auth = require 'db/auth'
Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
Board = undefined
queueRequire -> Board = require 'models/board'
BoardView = undefined
queueRequire -> BoardView = require 'views/board/board-view'
Browser = require 'lib/browser'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
PostRender = require 'views/lib/post-render'
Promise = require 'bluebird'
RequestToJoinView = undefined
queueRequire -> RequestToJoinView = require 'views/board/request-to-join-view'
simpleTest = require 'lib/experiments/simple-test'
Util = require 'lib/util'
_ = require 'underscore'
$ = require 'jquery'
assert = require 'lib/assert'
f = require 'effing'
log = require 'debug/log'
makeErrorEnum = require 'lib/make-error-enum'
moment = require 'moment'
ninvoke = require 'lib/util/ninvoke'
track = require 'debug/track'

DisplayBoardError = makeErrorEnum 'DisplayBoard', [
  'ConfirmToView'
  'CardNotFound'
  'CardNotFoundOnThisBoard'
  'BoardNotFound'
]

boardCache = (idBoard) -> "board_#{idBoard}"

fireAndForgetExtraBoardDataLoad = (idBoardOrShortLink, requiredDataPromise) ->
  requiredDataPromise ?= Promise.resolve()

  # Note that we should try to use the same id that would be used in
  # quickload, i.e. the shortLink
  loadSecondary = ModelLoader.for('top-level', 'loadBoardSecondary', idBoardOrShortLink)
  loadPluginData = ModelLoader.for('top-level', 'loadBoardPluginData', idBoardOrShortLink)

  Promise.all([
    loadSecondary,
    loadPluginData
  ])
  .catch ApiError, (->)
  .done()
  return

loadBoardData = (idBoardOrShortLink) ->
  requiredDataPromise =
    ModelLoader.for 'top-level', 'loadCurrentBoardData', idBoardOrShortLink

  # The browser may limit how many concurrent requests we can make, so do
  # the secondary ones after the first one has started
  fireAndForgetExtraBoardDataLoad(idBoardOrShortLink, requiredDataPromise)

  requiredDataPromise
  .catch ApiError.Unconfirmed, -> Promise.reject DisplayBoardError.ConfirmToView()
  .catch ApiError, -> Promise.reject DisplayBoardError.BoardNotFound()

getRenderLock = ->
  PostRender.hold()
  Promise.resolve().disposer -> PostRender.release()

module.exports =
  showCardOnBoard: (idCard, highlight, board, replyToComment, loadCardData) ->
    Promise.try ->
      if (card = board.getCard(idCard))?
        # We're making the assumption here that if we can find the card, then we
        # don't need to call loadCardData.  If we don't have e.g.
        # the idBoard, idList or name then we know for sure that we've
        # violated that assumption.
        assert card.get('idBoard')? && card.get('idList')? && card.get('name')?,
          "Tried to display a card that was only partially loaded"
        card
      else
        loadCardData idCard
        .tap (card) ->
          if card.get('idBoard') != board.id
            Promise.reject(DisplayBoardError.CardNotFoundOnThisBoard('', { idBoard: board.id }))
          return
    .then (card) =>
      @showCardDetail card, { highlight, replyToComment }

  showBoardDetailView: (args, boardView) -> Promise.try =>
    board = boardView.model

    if (idCard = args.idCard)?
      @showCardOnBoard idCard, args.highlight, board, args.replyToComment, args.loadCardData
    else if args.usernameBoardProfile &&
            (member = board.modelCache.findOne 'Member', 'username', args.usernameBoardProfile)?
      boardView.showMemberProfile(member)
    else if args.section in ['power-up', 'power-ups']
      if board.editable()
        boardView.showDirectory(args.directorySection, args.directoryCategory, args.directoryIdPowerUp)
      else
        @setBoardLocation(board.id)
    else if (date = args.calendarDate)?
      boardView.showCalendar date
    else
      if args.openListComposer
        boardView.openListComposer()
      if args.openCardComposerInFirstList
        # Deferred to ensure "Add a card" button below composer is hidden properly
        _.defer -> boardView.openCardComposerInFirstList()
      @setBoardLocation(board.id, args.section)

  renderBoard: (board, options) ->
    Promise.resolve if @onBoardView(board.id)
      boardView = @existingTopLevelView(BoardView, board)
      boardView.closeDetailView()
      boardView
    else
      @clearPreviousView()
      @setViewType(board)
      @showHeader()
      @maybeShowFooterChrome(@getBoardUrl(board.id))

      boardView = @topLevelView BoardView, board, _.extend(options, {
        modelCache: board.modelCache
      })

      $('#content').html(boardView.render().el)
      $('body').addClass('body-board-view')

      boardView

  renderRequestToJoin: (idBoard) ->
    @clearPreviousView()
    @showHeader()

    requestToJoinView = @topLevelView RequestToJoinView, Auth.me(), {
      idBoard: idBoard
    }

    $('#content').html(requestToJoinView.render().el)

  settingsFromQuery: ->
    _.chain(location.search.substr(1).split('&'))
      .map (entry) -> entry.split('=', 2)
      .filter ([key]) ->
        key in ['menu', 'filter']
      .map ([key, value]) ->
        [key, decodeURIComponent(value)]
      .object()
      .value()

  displayBoard: (settings) ->
    log('controller', ['boardView', settings.idBoard])
    startTime = Date.now()

    { idBoard, idCard } = settings
    assert idBoard || idCard,
      "Illegal invocation of displayBoard: requires one of idBoard, or idCard"
    assert !idBoard? || Util.checkId(idBoard) || Util.isShortLink(idBoard),
      "Illegal invocation of displayBoard: idBoard must be a board ID or a short link (got \"#{idBoard}\")"
    assert !idCard? || Util.checkId(idCard) || Util.isShortLink(idCard),
      "Illegal invocation of displayBoard: idCard must be a card ID or a short link (got \"#{idCard}\")"

    # [LOADCARD]
    loadCardData = _.once (idCardOrShortLink) ->
      ModelLoader.for 'top-level', 'loadCardData', idCardOrShortLink
      .catch ApiError, -> Promise.reject(DisplayBoardError.CardNotFound())

    awaitView = ({ model }) =>
      new Promise (resolve) =>
        @waitForId model, resolve

    detailArgs = _.extend({ loadCardData }, settings)

    Promise.using @getSpinner(), =>
      ModelLoader.release('top-level')
      Promise.try =>
        if idCard?
          # If we're showing a card, we always want to load the data for it
          return loadCardData(idCard).call('get', 'idBoard')
        idBoard
      .then (idBoard) ->
        Promise.props
          loadStartTime: Date.now()
          board: loadBoardData(idBoard)
          timingLabel:
            if ModelLoader.getUpToDateBoard(idBoard)?
              "Known Board"
            else
              "New Board"
      .then ({ board, timingLabel, loadStartTime }) =>
        track("Timing", "Load", timingLabel, Date.now() - startTime)

        Promise.using getRenderLock(), =>
          renderStartTime = Date.now()
          @renderBoard board, { section: settings.section, settings: @settingsFromQuery() }
          .tap ->
            track("Timing", "Load and Render", timingLabel, Date.now() - startTime)
            track("Timing", "Render", timingLabel, Date.now() - renderStartTime)
          .tap awaitView
          .then f(@, 'showBoardDetailView', detailArgs)

      .catch DisplayBoardError.ConfirmToView, =>
        assert Auth.isLoggedIn(), "Got 401: 'Confirm to view' while not logged in"
        ninvoke ModelCache, 'waitFor', 'Member', Auth.myId()
        .then =>
          @displayErrorPage _.extend
            errorType: 'unconfirmedBoardNotFound'
          , Auth.me().toJSON()

      .catch DisplayBoardError.CardNotFound, =>
        @displayErrorPage
          errorType: 'cardNotFound'

      .catch DisplayBoardError.BoardNotFound, =>
        ModelLoader.await('headerData')
        .then ->
          if simpleTest('requestToJoin')?.get('enabled')
            ApiPromise
              url: "/1/boards/#{ idBoard }/myPermissions"
            .then ({ canRequestToJoin }) =>
              canRequestToJoin
            .catch ApiError, =>
              false
          else
            false
        .then (canRequestToJoin) =>
          if canRequestToJoin
            @renderRequestToJoin(idBoard)
          else
            @displayErrorPage
              errorType: 'boardNotFound'

      .catch DisplayBoardError.CardNotFoundOnThisBoard, ({ idBoard }) =>
        Alerts.show('card does not exist', 'warning', 'doesnotexist', 5000)
        @setBoardLocation(idBoard, settings.section)

# [LOADCARD]
#
# It's probable that we'll need to do two data loads in order to load the
# board: one to determine what board the card lives on, and another to load
# the card.
#
# It's *possible*, if bizarre QuickLoad race conditions play in our favor,
# that doing the naive thing will just *happen* to work -- if the timing
# is just right, QuickLoad will give us the same response back twice, and
# two calls create only one actual network request.
#
# But. Let's memoize it ourself just in case, so that we don't have to worry
# about QuickLoad's behavior changing and doubling the requests here.



// WEBPACK FOOTER //
// ./app/scripts/controller/display-board.coffee